import { Col, Pagination, Row } from "antd";
import { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { AiFillPlusCircle } from "react-icons/ai";
import { FaPlusSquare } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import useMedia from "use-media";
import { FaMinus } from "react-icons/fa6";

import {
  Box,
  Button,
  Image,
  Loader,
  Modal,
  Table,
  Text,
  TextField,
} from "../../components";
import { ApiCaller, Colors, Fonts, Images, Utils } from "../../config";
import { ServiceAction } from "../../store/actions";
import { Select } from 'antd';
import './style.css'

const defaultState = {
  name: "",
  subServices: [
    {
      name: ""
    }
  ]
}

const exportingServices = async (state, callback) => {
  const { limit, offset } = state
  try {
    let res = await ApiCaller.Get(`/admin/export/services?limit=${limit}&offset=${offset}`);
    if (res?.status == 200) {
      Utils.showSnackBar({ message: res?.data?.data?.message });
      callback && callback(res?.data?.data?.url)
    } else {
      Utils.showSnackBar({
        message: res?.data?.error?.message,
        severity: "error",
      });
    }
  } catch (error) {
    Utils.showSnackBar({
      message: error?.data?.error?.message,
      severity: "error",
    });
  }
}

function ServiceManagement() {
  const isTablet = useMedia({ minWidth: "768px" });
  const isMobile = useMedia({ minWidth: "450px" });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const services = useSelector((state) => state.service);

  const [showModal, setShowModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [singleServiceModal, setSingleServiceModal] = useState(false);
  const [selectedSubServices, setSelectedSubServices] = useState([]);
  const [editService, setEditService] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedService, setSelectedService] = useState({});
  const [error, setError] = useState({
    id: "",
    name: "",
    subService: { name: "", index: 0 },
    image: "",
  });

  const [priorityList, setPriorityList] = useState([])

  const [checkServiceNameUpdate, setCheckServiceNameUpdate] = useState('')

  const [listOfServices, setListOfServices] = useState([])

  const [service, setService] = useState({
    serviceName: "",
    subServices: [""],
    serviceImage: null,
  });
  const [state, setState] = useState({
    limit: 10,
    offset: 0,
    search: "",
    status: "",
  });
  const [deleteSubServiceIndex, setDeleteService] = useState("");

  const [createServices, setCreateServices] = useState({
    name: "",
    subServices: [defaultState]
  });

  const [exportModal, setExportModal] = useState(false);



  // setting priority list
  useEffect(() => {
    let count = Array.from({ length: services?.count }, (_, i) => i + 1);
    setPriorityList(
      count.map((item) => {
        return {
          value: item,
          label: item
        }
      })
    )
    setListOfServices(services?.services)
  }, [services])

  // const handleAddMoreSubservices = () => {
  //   // let err = [...error.subService];
  //   var bool = false;
  //   service.subServices.forEach((subService, index) => {
  //     const subServiceName = subService.name ? subService.name : subService; // Handle both object and string cases
  //     if (subServiceName) {
  //       if (subServiceName?.trim() !== "") {
  //         err[index] = "";
  //       } else {
  //         bool = true;
  //         err[index] = "Please enter sub service name";
  //       }
  //     } else {
  //       if (subServiceName?.trim() !== "") {
  //         err[index] = "";
  //       } else {
  //         bool = true;
  //         err[index] = "Please enter sub service name";
  //       }
  //     }
  //   });
  //   // setError({ ...error, subService: err });
  //   if (bool == false) {
  //     setService({
  //       ...service,
  //       subServices: [...service.subServices, ""],
  //     });
  //   }
  // };

  const handleDeleteSubservice = (id, deleteSubService) => {
    let cloneServices = [...listOfServices];
    let selectedService = cloneServices.find(item => item?.id == deleteSubService?.id);
    if (selectedService?.subServices && selectedService?.subServices?.length == 1) {
      Utils.showSnackBar({
        message: "There must be at least one sub service for a service",
        severity: "error",
      });
      return
    }
    if (selectedService?.subServices && selectedService?.subServices?.length > 1) {
      dispatch(
        ServiceAction.deleteService(id, () => {
          setDeleteModal(false);
          setSelectedService({});
          dispatch(ServiceAction.getAllServices(state));

          setShowModal(false);
          setSingleServiceModal(false);
        })
      );
      return;
    }
    else {
      Utils.showSnackBar({
        message: "There must be at least one sub service for a service",
        severity: "error",
      });
    }
  };

  const handleCreateService = () => {

    let secondLayerClone = [...createServices.subServices]
    if (!createServices.name) {
      setError({ ...error, name: "Service name is required" });
      return
    }
    else if (
      createServices.name?.trim() === "" ||
      !(
        Utils.alphaNumericRegex.test(createServices.name) &&
        isNaN(createServices.name)
      )
    ) {
      setError({ ...error, name: "Enter a valid service name" });
      return
    }
    else if (createServices.name?.length > 30) {
      setError({
        ...error,
        name: "Service name cannot be greater than 30 characters",
      });
      return
    }

    let secondLayerValidationIndex = secondLayerClone.findIndex(item => item?.name == '')
    if (secondLayerValidationIndex == 0 || secondLayerValidationIndex !== -1) {
      setError({
        ...error,
        subService: { index: secondLayerValidationIndex, name: "Sub Service is required" }
      })
    }

    else {
      // let err = [...error.subService];
      // var bool = false;
      // service.subServices.forEach((subService, index) => {
      //   const subServiceName = subService.name ? subService.name : subService; // Handle both object and string cases
      //   if (subServiceName) {
      //     if (subServiceName?.trim() !== "") {
      //       err[index] = "";
      //     }
      //     else {
      //       bool = true;
      //       err[index] = "Please enter sub service name";
      //     }
      //   }
      //   else {
      //     if (subService?.trim() !== "") {
      //       err[index] = "";
      //     } else {
      //       bool = true;
      //       err[index] = "Please enter sub service name";
      //     }
      //   }
      // });
      // if (bool == true) {
      //   setError({ ...error, name: "", subService: err });
      //   return;
      // }
      if (service.serviceImage === null) {
        setError({
          ...error,
          name: "",
          subService: "",
          image: "Service image is required",
        });
        return;
      }
      else {
        const formData = new FormData();
        formData.append("picture", service.serviceImage);
        formData.append(`payload`, JSON.stringify(createServices));

        // edit case payload creation
        // else { 
        //   if (service?.serviceName !== checkServiceNameUpdate || typeof (service?.serviceImage) === 'object') {
        //     formData.append("name", service.serviceName.trim());
        //     formData.append("picture", service.serviceImage);
        //   }
        //   let subServices = [];
        //   service.subServices.forEach((subService, index) => {
        //     if (subService?.id) {
        //       subServices.push({
        //         id: subService?.id,
        //         name: subService?.name
        //       })
        //     }
        //     else {
        //       subServices.push({
        //         id: null,
        //         name: subService?.name
        //       })
        //     }
        //   })
        //   myPayload = {
        //     subServices,
        //     formData,
        //     parentId: service?.id
        //   }
        //   console.log(myPayload)
        // };

        // editService
        //   ? dispatch(
        //     ServiceAction.updateService(service.id, myPayload, () => {
        //       setShowModal(false);
        //       setService({
        //         serviceName: "",
        //         subServices: [""],
        //         serviceImage: null,
        //       });
        //       dispatch(ServiceAction.getAllServices(state));
        //     })
        //   )
        //   : 
        dispatch(
          ServiceAction.addService(formData, () => {
            dispatch(ServiceAction.getAllServices(state));
            setShowModal(false);
            setCreateServices({
              name: "",
              subServices: [
                {
                  name: "",
                  subServices: [
                    {
                      name: ""
                    }
                  ]
                }
              ]
            })
            setService({
              serviceName: "",
              subServices: "",
              serviceImage: null,
            });
            setError({
              name: "",
              subService: "",
              image: "",
            });
          })
        );
      }
    }
  };

  const handleDeleteService = (id) => {
    dispatch(
      ServiceAction.deleteService(id, () => {
        setDeleteModal(false);
        setSelectedService({});
        dispatch(ServiceAction.getAllServices(state));
      })
    );
  };

  const DragAreaContent = () => {
    return (
      <div className="drag-area-div">
        <img src={Images.UploadFileIcon} />
        <Text.Heading
          className="drag-area-text-heading"
          fontSize={14}
          fontFamily={Fonts["Poppins-Bold"]}
          color={Colors.BlueText}
          fontWeight={600}
          text={service.serviceImage === null ? "Upload a photo" : "Uploaded"}
          textAlign="center"
        />
        <Text.Heading
          fontSize={12}
          fontFamily={Fonts["Poppins-Medium"]}
          color={Colors.BlueText}
          fontWeight={500}
          text={
            "Supported formats PNG, JPEG or JPG. Photos are usually 100 x 100"
          }
          textAlign="center"
        />
      </div>
    );
  };

  const handleNavigateServiceDetails = (record) => {
    navigate("/service-management/details", {
      state: {
        record,
      },
    });
  };


  const handlePaginationChange = (pageNumber) => {
    let offset = (pageNumber - 1) * state.limit;
    setState({ ...state, offset: offset });
    setPage(pageNumber);
  };

  useEffect(() => {
    dispatch(ServiceAction.getAllServices(state));
  }, [state]);

  const priorityHandler = (value, record) => {
    const payload = {
      id: record?.id,
      oldPriority: record?.priority,
      newPriority: value
    }
    dispatch(ServiceAction.updatePriority(payload, () => {
      dispatch(ServiceAction.getAllServices(state));
    }))
  }

  // third layer add n remove handler.
  const thirdAddNRemoveHandler = (index, action, innerIndex) => {
    setCreateServices((prev) => {
      // Clone the current subServices
      const updatedSubServices = [...prev.subServices];
      // Get the second layer object to update
      const secondLayerObject = { ...updatedSubServices[index] };

      if (action == 'add') {
        if (secondLayerObject?.subServices?.length >= 3) {
          // Prevent adding more if the limit is reached
          return prev;
        }

        // Add a new empty third-layer sub-service
        secondLayerObject.subServices = [
          ...secondLayerObject.subServices,
          { name: "" },
        ];
      }

      else {
        secondLayerObject.subServices.splice(innerIndex, 1);
      }


      // Update the specific second layer
      updatedSubServices[index] = secondLayerObject;

      // Return the updated state
      return {
        ...prev,
        subServices: updatedSubServices,
      };
    });
  };

  const secondAndThirdAddNRemoveHandler = (index, action) => {
    let cloneCreatedServices = { ...createServices };

    if (cloneCreatedServices?.subServices?.length == 3 && action == 'add') {
      return
    }

    setCreateServices((prev) => {
      // Clone the current subServices
      const updatedSubServices = [...prev.subServices];
      if (action == 'add') {
        const defaultState =
        {
          name: "",
          subServices: [
            {
              name: ""
            }
          ]
        }

        return {
          ...prev,
          subServices: [...prev.subServices, defaultState]
        }

      }

      else {
        updatedSubServices.splice(index, 1);
        return {
          ...prev,
          subServices: updatedSubServices
        }
      }

    })
  }

  // update service
  const handleUpdateService = () => {
    if (!service.serviceName) {
      setError({ ...error, name: "Service name is required" });
      return
    }
    else if (
      service.serviceName?.trim() === "" ||
      !(
        Utils.alphaNumericRegex.test(service.serviceName) &&
        isNaN(service.serviceName)
      )
    ) {
      setError({ ...error, name: "Enter a valid service name" });
      return
    }
    else if (service.serviceName?.length > 30) {
      setError({
        ...error,
        name: "Service name cannot be greater than 30 characters",
      });
      return
    }
    if (service.serviceImage === null) {
      setError({
        ...error,
        name: "",
        subService: "",
        image: "Service image is required",
      });
      return;
    }
    else {
      // edit case payload creation
      const formData = new FormData();
      if (typeof (service?.serviceImage) == 'object') {
        formData.append("picture", service.serviceImage);
      }
      formData.append("name", service.serviceName);
      // let subServices = [];
      // service.subServices.forEach((subService, index) => {
      //   if (subService?.id) {
      //     subServices.push({
      //       id: subService?.id,
      //       name: subService?.name
      //     })
      //   }
      //   else {
      //     subServices.push({
      //       id: null,
      //       name: subService?.name
      //     })
      //   }
      // })
      const myPayload = {
        // subServices,
        formData,
        parentId: service?.id
      }

      dispatch(
        ServiceAction.updateService(service?.id, myPayload, () => {
          setEditService(false);
          setService({
            serviceName: "",
            subServices: [""],
            serviceImage: null,
          });
          dispatch(ServiceAction.getAllServices(state));
        })
      )
    }
  }


  // export date handler
  const exportDataHandler = () => {
    exportingServices(state, (res) => {
      window.open(res, "_blank");
      setExportModal(false)
    })
  }


  return (
    <>
      <Box>
        <Row justify="space-between">
          <Col className="flex-row-start">
            <Text.Heading
              fontSize={isMobile ? 24 : 20}
              fontFamily={Fonts["Poppins-SemiBold"]}
              color={Colors.Black}
              fontWeight={600}
              text={"Service Management"}
            />
          </Col>
          {services.services.length < 50 && (
            <Col
              md={8}
              sm={21}
              xs={24}
              className={
                isTablet
                  ? "flex-end"
                  : isMobile
                    ? "flex-row-start mt-20"
                    : "row-flex-center mt-20"
              }
            >
              <Button.Basic
                onClick={() => {
                  setExportModal(true);
                }}
                text={"Export Data"}
                className="add-admin-btn export-btn"
              />

              <Button.Basic
                onClick={() => {
                  setShowModal(true);
                }}
                text={"Add Service"}
                startIcon={<AiFillPlusCircle color="white" />}
                className="add-admin-btn submit-btn"
              />
            </Col>
          )}
        </Row>
        <Row justify="space-between" className="mt-20">
          <Col span={24}>
            {services.isLoading ? (
              <Col className="row-flex-center mt-20">
                <Loader.Circular />
              </Col>
            ) : (
              <>
                <Table.AntDesignTable
                  className="sub-admin-table"
                  columns={[
                    {
                      title: "Image",
                      dataIndex: "imageThumbUrl",
                      key: "imageThumbUrl",
                      render: (text, record) => (
                        <span
                          onClick={() => {
                            handleNavigateServiceDetails(record);
                          }}
                        >
                          <Image
                            className="sub-admin-avatar"
                            src={text}
                            fallback={Images.PlaceHolderImage}
                            alt="service"
                          />
                        </span>
                      ),
                    },
                    {
                      title: "Service Name",
                      dataIndex: "name",
                      key: "name",
                      render: (text, record) => {
                        return (
                          <span
                            onClick={() => {
                              handleNavigateServiceDetails(record);
                            }}
                          >
                            {text}
                          </span>
                        );
                      },
                    },
                    {
                      title: "Sub Service",
                      dataIndex: "noOfSubServices",
                      key: "noOfSubServices",
                      render: (text, record) => {
                        return (
                          <span
                            onClick={() => {
                              handleNavigateServiceDetails(record);
                            }}
                          >
                            {text === null
                              ? "-"
                              : text}
                          </span>
                        );
                      },
                    },
                    {
                      title: "No Of Users",
                      dataIndex: "noOfUsers",
                      key: "noOfUsers",
                      render: (text, record) => {
                        return <span>{text === null ? "-" : text}</span>;
                      },
                    },
                    {
                      title: "Priority",
                      dataIndex: "priority",
                      key: "priority",
                      render: (text, record) => {
                        return <Select options={priorityList} onChange={(value) => priorityHandler(value, record)} value={record?.priority} className="select-priority" />;
                      },
                    },
                    {
                      title: "Action",
                      dataIndex: "subscription",
                      key: "subscription",
                      render: (text, record) => {
                        return (
                          <span>
                            <img
                              src={Images.EditIcon}
                              onClick={() => {
                                setService({
                                  id: record.id,
                                  serviceName: record.name,
                                  serviceImage: record.imageUrl,
                                });
                                // setCheckServiceNameUpdate(record?.name)
                                setEditService(true);
                              }}
                            />{" "}
                            <img
                              onClick={() => {
                                setSelectedService(record);
                                setDeleteModal(true);
                              }}
                              src={Images.DeleteIcon}
                            />
                          </span>
                        );
                      },
                    },
                  ]}
                  data={services.services}
                  pagination={true}
                  rowKey="key"
                  loading={false}
                />
                <Row justify="center" className="mt-20">
                  <Col>
                    <Pagination
                      responsive="true"
                      showLessItems="true"
                      pageSize={10}
                      current={page}
                      total={services.count}
                      onChange={handlePaginationChange}
                    />
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>
      </Box>
      {deleteModal && (
        <Modal.ConfirmationModal
          centered={true}
          title={""}
          isModalVisible={deleteModal}
          heading={"Are you sure you want to delete this service?"}
          subHeading={
            "All the sub services related to this service will be deleted."
          }
          handleCancel={() => setDeleteModal(false)}
          handleDelete={() => handleDeleteService(selectedService.id)}
        ></Modal.ConfirmationModal>
      )}
      {singleServiceModal && (
        <Modal.ConfirmationModal
          title={""}
          isModalVisible={singleServiceModal}
          heading={"Are you sure you want to delete sub service?"}
          handleCancel={() => setSingleServiceModal(false)}
          handleDelete={() => {
            if (deleteSubServiceIndex) {
              const deleteSubService = { ...service };
              deleteSubService.subServices.splice(deleteSubServiceIndex, 1);
              setService(deleteSubService);
              setSingleServiceModal(false);
            } else {
              const deleteSubService = { ...service };
              handleDeleteSubservice(selectedService.id, deleteSubService);
            }

            // setSelectedSubServices((prev) => {
            //   console.log("PREV HMMM", prev);
            //   return prev.filter(
            //     (subServ) => subServ.id !== selectedService.id
            //   );
            // });
          }}
        ></Modal.ConfirmationModal>
      )}
      {showModal && (
        <Modal.AntDesignModal
          title=""
          isModalVisible={showModal}
          centered={true}
          destroyOnClose={true}
          maskClosable={false}
          handleCancel={() => {
            setService({
              // serviceName: "",
              // subServices: [""],
              serviceImage: null,
            });
            setCreateServices({
              name: "",
              subServices: [defaultState]
            })
            setError({
              name: "",
              subService: "",
              image: "",
            });
            setShowModal(false);
          }}
        >
          <Row justify="center">
            <Col>
              <Text.Heading
                fontSize={24}
                fontFamily={Fonts["Poppins-SemiBold"]}
                color={Colors.Black}
                fontWeight={600}
                text={"Add Service"}
              />
            </Col>
          </Row>
          <Row justify="end" className="mt-20">
            <Col span={24}>
              <TextField.CustomInput
                label={<span>{`Service Name: `} <span className="imp-tag">* </span></span>}
                placeholder="Enter Service Name"
                value={createServices.name}
                size="large"
                type="text"
                className="user-subject-field"
                onChange={(e) =>
                  setCreateServices((prev) => ({ ...prev, name: e.target.value }))
                }
              />
              {/*  for error */}
              <Text.Heading
                fontSize={14}
                fontFamily={Fonts["Poppins-Regular"]}
                color={"red"}
                fontWeight={400}
                text={error.name}
                textAlign="end"
                className="mt-10"
              />
            </Col>
            {
              // mapping second layer
              createServices?.subServices?.length > 0 ?
                createServices?.subServices?.map((secondLayer, index) => {
                  return (
                    <>
                      <Col span={20} key={index}>
                        <TextField.CustomInput
                          label={<span>{`Sub Service Name: `} <span className="imp-tag">* </span></span>}
                          placeholder="Sub Service"
                          value={secondLayer.name}
                          size="large"
                          type="text"
                          className="user-subject-field"
                          name={secondLayer.name}
                          onChange={(e) => {
                            const updatedSubServices = [...createServices.subServices];
                            updatedSubServices[index].name = e.target.value; // Update specific sub-service
                            setCreateServices((prev) => ({
                              ...prev,
                              subServices: updatedSubServices,
                            }));
                          }}
                        />
                        {/*  for error */}
                        <Text.Heading
                          fontSize={14}
                          fontFamily={Fonts["Poppins-Regular"]}
                          color={"red"}
                          fontWeight={400}
                          text={index == error?.subService?.index && error?.subService?.name}
                          textAlign="end"
                          className="mt-10"
                        />
                        {
                          index !== 0 && <span onClick={() => secondAndThirdAddNRemoveHandler(index, 'remove')} className="minus-icon"><FaMinus size={23} /></span>
                        }
                      </Col>
                      {
                        // mapping third layer
                        secondLayer?.subServices?.length > 0 ?
                          secondLayer?.subServices?.map((thirdLayer, innerIndex) => (
                            <Col lg={18} key={innerIndex} className="col-style">
                              <TextField.CustomInput
                                label="Secondary Services:"
                                placeholder="Optional"
                                value={thirdLayer.name}
                                size="large"
                                type="text"
                                className="user-subject-field"
                                name={thirdLayer.name}
                                onChange={(e) => {
                                  setCreateServices((prev) => {
                                    // Deep clone the subServices
                                    const updatedSubServices = [...prev.subServices];
                                    // Access the current second layer
                                    const updatedSecondLayer = { ...updatedSubServices[index] };
                                    // Update the specific third-layer sub-service
                                    updatedSecondLayer.subServices[innerIndex].name = e.target.value;
                                    // Replace the updated second layer in the subServices array
                                    updatedSubServices[index] = updatedSecondLayer;
                                    return {
                                      ...prev,
                                      subServices: updatedSubServices,
                                    };
                                  });
                                }}
                              />
                              <span onClick={() => thirdAddNRemoveHandler(index, 'delete', innerIndex)} className="minus-icon"><FaMinus size={23} /></span>
                              {
                                innerIndex === secondLayer?.subServices?.length - 1 && <span onClick={() => thirdAddNRemoveHandler(index, 'add', innerIndex)} className="add-icon"><FaPlusSquare color="#FAB700" size={18} /> Add more</span>
                              }
                            </Col>
                          ))
                          : null
                      }
                    </>
                  )
                })
                :
                null
            }
            <>
              <div className="div-width">
                <span onClick={() => secondAndThirdAddNRemoveHandler(0, 'add')} className="add-icon"><FaPlusSquare color="#FAB700" size={18} /> Add Sub Service</span>
              </div>
            </>
          </Row>
          {/* {service.subServices.map((subService, index) => {
            console.log(subService)
            return (
              <Row justify="center" className="my-10-20">
                <Col span={24}>
                  <TextField.CustomInput
                    label={
                      index === 0
                        ? `Sub Service Name`
                        : `Sub Service Name ${index + 1}`
                    }
                    placeholder="Enter Sub Service Name"
                    suffix={
                      <img
                        className="cursor"
                        onClick={() => {
                          if (!subService.id) {
                            setDeleteService(index);
                            setSelectedService({});
                          } else {
                            setDeleteService("");
                            setSelectedService(subService);
                          }
                          setSingleServiceModal(true);

                          // if (subService.new) {
                          //   setSelectedSubServices((prev) =>
                          //     prev.filter(
                          //       (subServ) => subServ.id !== subService.id
                          //     )
                          //   );
                          // } else {
                          //   const deletedSubservice = selectedSubServices.find(
                          //     (sub) => sub.id === subService.id
                          //   );
                          //   setSelectedService(deletedSubservice);
                          //   setDeleteModal(true);
                          // }
                        }}
                        src={Images.DeleteSubServiceIcon}
                        width={20}
                      />
                    }
                    value={subService.name}
                    size="large"
                    type="text"
                    className="user-subject-field"
                    onChange={(e) =>
                      setService({
                        ...service,
                        subServices: service.subServices.map((subService, i) =>
                          i === index
                            ? { ...subService, name: e.target.value } // Only update the name key
                            : subService // Keep other objects unchanged
                        ),
                      })
                    }

                  />
                  <Text.Heading
                    fontSize={14}
                    fontFamily={Fonts["Poppins-Regular"]}
                    color={"red"}
                    fontWeight={400}
                    text={error.subService[index]}
                    textAlign="center"
                    className="mb-10"
                  />
                </Col>
              </Row>
            );
          })}
          {service.subServices.length < 20 && (
            <Col className="row-flex-end">
              <Button.Basic
                startIcon={<img src={Images.AddSquareIcon} alt="" />}
                text={"Add More"}
                className="add-more-btn"
                onClick={handleAddMoreSubservices}
              />
            </Col>
          )} */}

          {/* image handling */}
          <Row justify="center" className="drag-area-row">
            <Col>
              <Dropzone
                onDrop={(acceptedFiles) => {
                  let dot = acceptedFiles[0].path.split(".");
                  if (
                    acceptedFiles[0].path.split(".")[dot.length - 1]?.toLowerCase() ===
                    "png" ||
                    acceptedFiles[0].path.split(".")[dot.length - 1]?.toLowerCase() ===
                    "jpeg" ||
                    acceptedFiles[0].path.split(".")[dot.length - 1]?.toLowerCase() === "jpg"
                    // acceptedFiles[0].type === "image/jpeg" ||
                    // acceptedFiles[0].type === "image/png"
                  ) {
                    Utils.showSnackBar({
                      message: "Image uploaded successfully",
                    });
                    setService({ ...service, serviceImage: acceptedFiles[0] });
                    setError({
                      ...error,
                      image: "",
                    });
                  } else {
                    Utils.showSnackBar({
                      message: "Image format not supported",
                      severity: "error",
                    });
                  }
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <DragAreaContent />
                    </div>
                  </section>
                )}
              </Dropzone>
              {error && (
                <Text.ErrorText
                  fontSize={14}
                  fontFamily={Fonts["Poppins-Regular"]}
                  color={"red"}
                  fontWeight={400}
                  text={error.image}
                />
              )}
            </Col>
          </Row>
          <Row justify="center">
            <Col span={24}>
              <Button.Basic
                onClick={handleCreateService}
                text={"Submit"}
                className="service-provider-email-btn"
              />
            </Col>
          </Row>
        </Modal.AntDesignModal>
      )}
      {editService && (
        <Modal.AntDesignModal
          title=""
          isModalVisible={editService}
          centered={true}
          destroyOnClose={true}
          maskClosable={false}
          handleCancel={() => {
            setService({
              // serviceName: "",
              // subServices: [""],
              serviceImage: null,
            });
            setError({
              name: "",
              subService: "",
              image: "",
            });
            setEditService(false);
          }}
        >
          <Row justify="center">
            <Col>
              <Text.Heading
                fontSize={24}
                fontFamily={Fonts["Poppins-SemiBold"]}
                color={Colors.Black}
                fontWeight={600}
                text={"Edit Service"}
              />
            </Col>
          </Row>
          <Row justify="end" className="mt-20">
            <Col span={24}>
              <TextField.CustomInput
                label={<span>{`Service Name: `} <span className="imp-tag">* </span></span>}
                placeholder="Enter Service Name"
                value={service.serviceName}
                size="large"
                type="text"
                className="user-subject-field"
                onChange={(e) =>
                  setService((prev) => ({ ...prev, serviceName: e.target.value }))
                }
              />
              {/*  for error */}
              <Text.Heading
                fontSize={14}
                fontFamily={Fonts["Poppins-Regular"]}
                color={"red"}
                fontWeight={400}
                text={error.name}
                textAlign="end"
                className="mt-10"
              />
            </Col>
          </Row>


          {/* image handling */}
          <Row justify="center" className="drag-area-row">
            <Col>
              <Dropzone
                onDrop={(acceptedFiles) => {
                  let dot = acceptedFiles[0].path.split(".");
                  if (
                    acceptedFiles[0].path.split(".")[dot.length - 1]?.toLowerCase() ===
                    "png" ||
                    acceptedFiles[0].path.split(".")[dot.length - 1]?.toLowerCase() ===
                    "jpeg" ||
                    acceptedFiles[0].path.split(".")[dot.length - 1]?.toLowerCase() === "jpg"
                    // acceptedFiles[0].type === "image/jpeg" ||
                    // acceptedFiles[0].type === "image/png"
                  ) {
                    Utils.showSnackBar({
                      message: "Image uploaded successfully",
                    });
                    setService({ ...service, serviceImage: acceptedFiles[0] });
                    setError({
                      ...error,
                      image: "",
                    });
                  } else {
                    Utils.showSnackBar({
                      message: "Image format not supported",
                      severity: "error",
                    });
                  }
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <DragAreaContent />
                    </div>
                  </section>
                )}
              </Dropzone>
              {error && (
                <Text.ErrorText
                  fontSize={14}
                  fontFamily={Fonts["Poppins-Regular"]}
                  color={"red"}
                  fontWeight={400}
                  text={error.image}
                />
              )}
            </Col>
          </Row>
          <Row justify="center">
            <Col span={24}>
              <Button.Basic
                onClick={handleUpdateService}
                text={"Save Changes"}
                className="service-provider-email-btn"
              />
            </Col>
          </Row>
        </Modal.AntDesignModal>
      )}

      {
        exportModal &&
        <Modal.ConfirmationModal
          title={""}
          isModalVisible={exportModal}
          heading={"Are you sure you want to export?"}
          handleCancel={() => setExportModal(false)}
          handleDelete={() => exportDataHandler()}
        >
        </Modal.ConfirmationModal>
      }
    </>
  );

}

export default ServiceManagement;
